// --- Global ---

const AB_TEST_INCLUDES = ['ab_test_configuration.click_event_triggers'];

const CAMPAIGN_FOOTER_INCLUDES = [
  // 'campaign_footer',
  // 'campaign_footer.footer_nav',
  // 'campaign_footer.footer_nav.content',
  'campaign_footer.disclosure',
  'campaign_footer.footer_nav.content.content',
  'campaign_footer.footer_nav.content.link',
];

const CAMPAIGN_HEADER_INCLUDES = [
  // 'campaign_header',
  // 'campaign_header.navigation_menu',
  // 'campaign_header.navigation_menu.content',
  // 'campaign_header.navigation_menu.content.content',
  'campaign_header.navigation_menu.content.content.content',
  'campaign_header.navigation_menu.content.link',
  'campaign_header.navigation_menu.content.logo_link',
];

// --- page_components ---

const ARTICLES_BY_CATEGORY_INCLUDES = ['page_components.articles_by_category.category'];

const AWARD_INCLUDES = ['page_components.award_section.award'];

const BREAKER_INCLUDES = ['page_components.breaker_section.breaker'];

const CARD_CAROUSEL_INCLUDES = [
  // 'page_components.card_carousel_section.card_carousel',
  'page_components.card_carousel_section.card_carousel.inline_cards.cards.disclosure',
  'page_components.card_carousel_section.card_carousel.inline_cards.cards.line_card_fields.link',
  'page_components.card_carousel_section.card_carousel.inline_cards.cards.trigger',
];

const COMPARISON_TABLE_INCLUDES = ['page_components.comparison_table.comparison_table'];

const CTA_EMAIL_INCLUDES = [
  // 'page_components.cta_email_section.cta_email',
  'page_components.cta_email_section.cta_email.disclosure',
];

const CTA_INCLUDES = [
  // 'page_components.cta.call_to_action',
  // 'page_components.cta.call_to_action.button',
  'page_components.cta.call_to_action.button.link',
  'page_components.cta.call_to_action.disclosure',
];

const DISCLOSURE_SECTION_INCLUDES = ['page_components.disclosure_section.disclosure'];

const FEATURED_ARTICLES_INCLUDES = [
  // 'page_components.featured_articles_section.button',
  // 'page_components.featured_articles_section.featured_article',
  // 'page_components.featured_articles_section.featured_article.topic_column.articles.category',
  'page_components.featured_articles_section.button.link',
  'page_components.featured_articles_section.featured_article.topic_column.articles',
  'page_components.featured_articles_section.featured_article.topic_column.articles.category.category',
  'page_components.featured_articles_section.featured_article.topic_column.articles.category.sub_category',
  'page_components.featured_articles_section.featured_article.topic_column.category',
];

const PRODUCT_FEATURE_INCLUDES = ['page_components.product_feature_section.product_feature_cards'];

const SUB_NAV_INCLUDES = ['page_components.sub_nav_section.sub_nav'];

const TAB_SECTION_INCLUDES = [
  'page_components.tab_section.inline_tabs.tab_content',
  'page_components.tab_section.inline_tabs.tab_content.content.comparison_table.comparison_table',
  'page_components.tab_section.inline_tabs.tab_content.content.text_block.text_block',
  'page_components.tab_section.inline_tabs.tab_content.content.text_block.text_block.cta.link',
  'page_components.tab_section.inline_tabs.tab_content.content.text_block.text_block.disclosure',
];

const TEXT_BLOCK_SECTION_INCLUDES = [
  // 'page_components.text_block_section.inline_text_block.cta',
  'page_components.text_block_section.inline_text_block.cta.link',
  'page_components.text_block_section.inline_text_block.disclosure',
];

const TWO_COL_INCLUDES = [
  // 'page_components.two_column_media_text_block_section.two_col_media_text_block',
  // 'page_components.two_column_media_text_block_section.two_col_media_text_block.content.text_block.inline_text_block.cta',
  'page_components.two_column_media_text_block_section.two_col_media_text_block.content.comparison_table.comparison_table',
  'page_components.two_column_media_text_block_section.two_col_media_text_block.content.text_block.inline_text_block.cta.link',
  'page_components.two_column_media_text_block_section.two_col_media_text_block.content.text_block.inline_text_block.disclosure',
];

export const PAGE_INCLUDES: string[] = [
  ...AB_TEST_INCLUDES,
  ...CAMPAIGN_FOOTER_INCLUDES,
  ...CAMPAIGN_HEADER_INCLUDES,
  ...ARTICLES_BY_CATEGORY_INCLUDES,
  ...AWARD_INCLUDES,
  ...BREAKER_INCLUDES,
  ...CARD_CAROUSEL_INCLUDES,
  ...COMPARISON_TABLE_INCLUDES,
  ...CTA_EMAIL_INCLUDES,
  ...CTA_INCLUDES,
  ...DISCLOSURE_SECTION_INCLUDES,
  ...FEATURED_ARTICLES_INCLUDES,
  ...PRODUCT_FEATURE_INCLUDES,
  ...SUB_NAV_INCLUDES,
  ...TAB_SECTION_INCLUDES,
  ...TEXT_BLOCK_SECTION_INCLUDES,
  ...TWO_COL_INCLUDES,
];

export const buildIncludeQuery = (paths: string[]): string =>
  paths
    .slice()
    .sort()
    .map((p) => `include[]=${encodeURIComponent(p)}`)
    .join('&');
